import { useQuery } from '@apollo/client';
import FETCH_ORGANIZATIONS from 'src/graphql/querys/fetchOrganizations';
import { FetchOrganizationsQuery } from 'src/__generated__/graphql';

// Tipo query-scoped (no el `Organization` completo del schema): solo los campos que
// selecciona FetchOrganizations. Exportado para que los consumidores lo reusen.
export type Organization = FetchOrganizationsQuery['organizations'][number];

const useOrganizations = () => {
  const { data, loading, refetch } = useQuery(FETCH_ORGANIZATIONS);
  const organizations: Organization[] = data?.organizations ?? [];
  return { organizations, loading, refetch };
};

export default useOrganizations;
